<template>
    <div class="container my-5">
        <div class="row">
            <div class="col-12 text-center">
                <h1>Sucesso!</h1>
                <p>Agora, feche esta janela, abra seu e-mail e clique no link para acessar a plataforma.</p>
                <p>Obrigado!</p>

            </div>
        </div>
    </div>
</template>